<template>
  <v-row dense no-gutters class="fill-height mt-3">
    <v-col cols="12">
      <v-card flat outlined class="pr-3">
        <tbl-calculation-comp-conc-limits :components="COMPONENTS" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import TblCalculationCompConcLimits from '../tables/tblCalculationCompConcLimits.vue'
export default {
  name: 'rcptPropertiesPanel',
  mixins: [],
  props: {
    receipt: {
      type: Object,
      default: function () {
        return {}
      }
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  emits: ['onChange'],
  components: { TblCalculationCompConcLimits },
  data () {
    return {}
  },
  computed: {
    COMPONENTS: {
      get () {
        return this.receipt.COMPONENTS
      }
    }
  },
  watch: {
    activeTab (val) {
      console.log('rcptPropertiesPanel activeTab changed to ', val)
    }
  },
  methods: {
    onChangeReceipt (val) {
      this.$emit('onChange', val)
    }
  },
  mounted () {
    console.log('rcptPropertiesPanel mounted with receipt ', this.receipt)
  }
}
</script>
